export default __webpack_public_path__ + "static/media/Wrap of the Hell Walker (nm).cb74cdf1.jpg";